import { useState } from 'react';
import { SideDrawer } from '@/components';
import { AppointmentFormModal } from './AppointmentFormModal';
import { AppointmentPopover } from './AppointmentPopover';

function DrawerCloseButton({ onClick, disabled }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="w-8 h-8 rounded-[8px] bg-primary text-white flex items-center justify-center hover:bg-primary-hover transition-colors focus:outline-none shrink-0 disabled:opacity-50 disabled:cursor-not-allowed"
      aria-label="Close"
    >
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.75"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  );
}

function titleForMode(mode) {
  if (mode === 'edit') return 'Edit Appointment';
  if (mode === 'details') return 'Appointment Details';
  return 'New Appointment';
}

export function AppointmentDrawer({
  isOpen,
  onClose,
  mode = 'create',
  companyId,
  appointment = null,
  event = null,
  initialSlot = null,
  canUpdate = false,
  canDelete = false,
  canUpdateStatus = true,
  onEdit,
  onDelete,
  onContactClick,
  initialContact = null,
  onCreated,
}) {
  const [isBusy, setIsBusy] = useState(false);

  const handleClose = () => {
    if (isBusy) return;
    onClose?.();
  };

  return (
    <SideDrawer
      isOpen={isOpen}
      onClose={handleClose}
      width="md"
      className="appointment-drawer"
      zIndexClass="z-[60]"
      showClose={false}
      bodyClassName="p-0 flex flex-col min-h-0 !overflow-hidden"
      headerClassName="!px-4 !py-4"
      header={
        <div className="flex items-center justify-between w-full gap-3 min-w-0">
          <h2 className="text-[18px] leading-[26px] font-semibold text-[#1F2241] font-sf-pro-display truncate min-w-0">
            {titleForMode(mode)}
          </h2>
          <DrawerCloseButton onClick={handleClose} disabled={isBusy} />
        </div>
      }
    >
      {mode === 'details' ? (
        <AppointmentPopover
          companyId={companyId}
          event={event}
          canUpdate={canUpdate}
          canDelete={canDelete}
          onClose={handleClose}
          onEdit={onEdit}
          onDelete={onDelete}
          onContactClick={onContactClick}
          onBusyChange={setIsBusy}
        />
      ) : (
        <AppointmentFormModal
          key={
            mode === 'edit' ? `edit-${appointment?.id || 'unknown'}` : 'create'
          }
          isOpen={isOpen && (mode === 'create' || mode === 'edit')}
          onClose={handleClose}
          companyId={companyId}
          appointment={mode === 'edit' ? appointment : null}
          initialSlot={mode === 'create' ? initialSlot : null}
          initialContact={mode === 'create' ? initialContact : null}
          canUpdateStatus={canUpdateStatus}
          onBusyChange={setIsBusy}
          onCreated={onCreated}
        />
      )}
    </SideDrawer>
  );
}
